<template>
  <v-card
    flat
    rounded
    elevation="0"
    class="pa-6 ma-3"
    max-width="520"
    color="grey lighten-5"
  >
    <v-card-title class="justify-center pb-2">
      <h2 class="h6 font-weight-bold grey--text text--darken-2 text-center">
        {{ $t('teachers.impersonate_select_app') }}
      </h2>
    </v-card-title>

    <v-card-subtitle class="text-center pb-4">
      <span class="deep-purple--text font-weight-medium">{{ userName }}</span>
    </v-card-subtitle>

    <v-card-text>
      <v-row justify="center" class="mx-0">
        <!-- Teachers App Card -->
        <v-col cols="12" sm="6" class="pa-2">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 8 : 2"
              :class="['app-selector-card', { 'on-hover': hover }]"
              @click="selectApp('teachers')"
              height="180"
            >
              <v-card-text class="d-flex flex-column align-center justify-center h-100">
                <v-icon
                  size="56"
                  :color="hover ? 'deep-purple' : 'deep-purple lighten-2'"
                  class="mb-3"
                >
                  mdi-school
                </v-icon>
                <span
                  class="text-subtitle-1 font-weight-bold text-center grey--text text--darken-2"
                >
                  {{ $t('teachers.impersonate_teachers_app') }}
                </span>
                <span class="text-caption text-center grey--text mt-1">
                  {{ $t('teachers.impersonate_teachers_app_desc') }}
                </span>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>

        <!-- DataSystem Card -->
        <v-col cols="12" sm="6" class="pa-2">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 8 : 2"
              :class="['app-selector-card', { 'on-hover': hover }]"
              @click="selectApp('datasystem')"
              height="180"
            >
              <v-card-text class="d-flex flex-column align-center justify-center h-100">
                <v-icon
                  size="56"
                  :color="hover ? 'indigo' : 'indigo lighten-2'"
                  class="mb-3"
                >
                  mdi-chart-box
                </v-icon>
                <span
                  class="text-subtitle-1 font-weight-bold text-center grey--text text--darken-2"
                >
                  {{ $t('teachers.impersonate_datasystem') }}
                </span>
                <span class="text-caption text-center grey--text mt-1">
                  {{ $t('teachers.impersonate_datasystem_desc') }}
                </span>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-4">
        <v-btn
          text
          small
          color="grey darken-1"
          @click="onCancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ImpersonateAppSelectorModal',
  props: {
    userName: {
      type: String,
      default: '',
    },
  },
  methods: {
    selectApp(app) {
      this.$emit('onSelect', app);
    },
    onCancel() {
      this.$emit('onCancel');
    },
  },
};
</script>

<style scoped lang="scss">
.app-selector-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover,
  &.on-hover {
    border-color: #7c4dff;
    transform: translateY(-4px);
  }
}

.h-100 {
  height: 100%;
}
</style>
